import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=260910ee&scoped=true"
import script from "./BaseLogo.vue?vue&type=script&lang=js"
export * from "./BaseLogo.vue?vue&type=script&lang=js"
import style0 from "./BaseLogo.vue?vue&type=style&index=0&id=260910ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260910ee",
  null
  
)

export default component.exports